(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kelden-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => root.querySelectorAll('.kelden-faq details').forEach((item) => {
    if (item.dataset.enhanced) return;
    item.dataset.enhanced = 'true';
    const summary = item.querySelector('summary');
    const content = item.querySelector(':scope > div');
    let animation;
    let expanded = item.open;
    summary.addEventListener('click', (event) => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) return;
      event.preventDefault();
      const start = item.getBoundingClientRect().height;
      if (animation) { animation.onfinish = null; animation.cancel(); }
      expanded = !expanded;
      item.open = true;
      item.style.height = 'auto';
      const end = expanded ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height;
      item.style.overflow = 'hidden';
      animation = item.animate({height: [start + 'px', end + 'px']}, {duration: 260, easing: 'ease-in-out'});
      if (expanded) content.animate({opacity:[0,1],transform:['translateY(-4px)','translateY(0)']},{duration:260});
      animation.onfinish = () => { item.open = expanded; item.style.removeProperty('height'); item.style.removeProperty('overflow'); animation = null; };
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelden-promise"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const el = entry.target;
      el.animate([{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,easing:'ease-out'});
      const title = el.querySelector('strong');
      const text = title.textContent;
      const match = text.match(/^(\d+)(.*)$/);
      if (match) {
        title.setAttribute('aria-label', text);
        const visual = document.createElement('span');
        visual.setAttribute('aria-hidden', 'true');
        title.replaceChildren(visual);
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / 1400, 1);
          visual.textContent = Math.round(Number(match[1]) * (1 - Math.pow(1 - progress, 3))) + match[2];
          if (progress < 1 && el.isConnected) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }), {threshold:0.35});
    root.querySelectorAll('.kelden-promises > div').forEach((el) => {
      if (el.dataset.enhanced) return;
      el.dataset.enhanced = 'true';
      observer.observe(el);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
